import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import DartsDesign2 from "./DartsDesign2";

const Embed = (props) => {
  const { coinPairId, api_key } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [scale, setScale] = useState(1);
  const [containerSize, setContainerSize] = useState({ width: 100, height: 100 });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://cryptomarketdarts.com/api/darts/index.php?action=get_analyse_average_for_coin_ids&coin_pair_ids=${coinPairId}&api_key=${api_key}`
        );
        if (response.data.status) {
          setData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [coinPairId, api_key]);

  useEffect(() => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const min = Math.min(width, height);
    const calculatedScale = min / 200;

    setContainerSize({ width, height });
    setScale(calculatedScale);
  }, []);

  function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  if (loading) return <div>Loading...</div>;
  if (!data || data.length === 0) return <div>No data available</div>;

  return (
    <div
      style={{
        width: `${containerSize.width}px`,
        height: `${containerSize.height}px`,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        position: "relative",
        background: "transparent",
        margin: 0,
        padding: 0
      }}
    >
      <div
        style={{
          width: "200px",
          height: "200px",
          transform: `scale(${scale})`,
          transformOrigin: "top left",
          position: "absolute",
          left: 0,
          top: 0
        }}
      >
        {data.map((value) => (
          <span
            key={value["coin_pair_id"] + "_" + randomIntFromInterval(1, 100000)}
            onClick={() =>
              window.open(
                `https://cryptomarketdarts.com/EmbedRedirect/${value["coin_pair_id"]}/${value["coin_pair_name"]}/${api_key}`,
                "_blank"
              )
            }
            style={{
              display: "contents",
              cursor: "pointer"
            }}
          >
            <DartsDesign2
              coinPairId={value["coin_pair_id"]}
              name={value["coin_pair_name"]}
              userDetails={null}
              embed="embed"
              _values={value}
            />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Embed;
